import { useTranslation } from 'react-i18next';
import { item } from '../../utils/animations';
import styles from './FooterSubSections.module.css';
import { motion } from 'framer-motion';

export const FooterDownload = () => {
    const { t } = useTranslation();
    return (
        <motion.div
            className={styles.wrapper}
            variants={item}
        >
            <h1 className={styles.title}>
                {t('shared.download')}
            </h1>
            <div className={styles.body}>
                <img
                    src={require("../../../assets/images/img-app-store.png")}
                    alt="Download on the App Store"
                    className={styles.storeImage}
                    onClick={() =>
                        window.open(
                            "https://apps.apple.com/es/app/gluten-freends/id6479203808",
                            "_blank"
                        )
                    }
                />
                <img
                    src={require("../../../assets/images/img-google-play.png")}
                    alt="Download on Google Play"
                    className={styles.storeImage}
                    onClick={() =>
                        window.open(
                            "https://play.google.com/store/apps/details?id=com.glutenfreehub.app",
                            "_blank"
                        )
                    }
                />
            </div>
        </motion.div>
    )
}